/* eslint-disable */
import Vuex from 'vuex';
import Vue from 'vue'
import createPersistedState from "vuex-persistedstate";


import ClientStore from './modules/client'
Vue.use(Vuex)
const store = new Vuex.Store({
    modules : {
        client: ClientStore,
    },
    plugins: [createPersistedState()]
});

export default store;